import { Button, Field, SearchField } from 'components/commons';
import React, { useCallback } from 'react';
import styles from './books-of-accounts-filter.module.scss';

import DateRange from 'components/commons/date-range/date-range';
import BooksOfAccounts from 'enums/books-of-accounts';
import SelectAccount from 'components/field/select-account/select-account';

const BooksOfAccountsFilter = ({
  filterState,
  onSearchChange,
  onSearch,
  onDateRangeChange,
  onDownloadFile,
  onAccountChange,
  fetchingReport,
  bookAccountType,
  onClearFilter
}) => {
  const onDateRangeChangeCb = useCallback(
    (name, { value, dirty }) => {
      if (onDateRangeChange) return onDateRangeChange(value, dirty);
    },
    [onDateRangeChange]
  );

  const onAccountChangeCb = useCallback(
    (name, { label, value, dirty }) => {
      if (onAccountChange) return onAccountChange({ label, value }, dirty);
    },
    [onAccountChange]
  );

  const onSearchChangeCb = useCallback(
    (name, { value }) => {
      if (onSearchChange) {
        return onSearchChange('searchKey', { value });
      }
    },
    [onSearchChange]
  );

  const onSearchCb = useCallback(
    (searchKey) => {
      if (onSearch) {
        return onSearch(searchKey);
      }
    },
    [onSearch]
  );

  let searchPlaceholder = '';
  switch (bookAccountType) {
    case BooksOfAccounts.CashDisbursement:
      searchPlaceholder = 'OR Number';
      break;
    case BooksOfAccounts.CashReceipt:
      searchPlaceholder = 'Voucher Number';
      break;
    default:
      searchPlaceholder = 'Name, Category';
      break;
  }

  return (
    <div className={styles.filter}>
      <div className={styles.filterContent}>
        <Field className={styles.date} label={'Date'}>
          <DateRange
            value={{
              startDate: filterState.startDate,
              endDate: filterState.endDate
            }}
            onChange={onDateRangeChangeCb}
          />
        </Field>
        {[
          BooksOfAccounts.CashDisbursement,
          BooksOfAccounts.CashReceipt,
          BooksOfAccounts.GeneralJournal,
          BooksOfAccounts.GeneralEntriesBook
        ].includes(bookAccountType) && (
          <Field className={styles.search} label="Search">
            <SearchField
              placeholder={searchPlaceholder}
              value={filterState.searchKey}
              onChange={onSearchChangeCb}
              onEnter={onSearchCb}
              restrict={false}
            />
          </Field>
        )}
        {bookAccountType === BooksOfAccounts.GeneralLedger && (
          <Field className={styles.account} label="Select Account">
            <SelectAccount
              value={filterState?.accountId?.value}
              placeholder="Select Account"
              onChange={onAccountChangeCb}
              label={filterState?.accountId?.label}
            />
          </Field>
        )}
      </div>
      <Field>
        <Button outline onClick={onClearFilter} className={styles.clearFilter}>
          Clear Filter
        </Button>
      </Field>
      <Field className={styles.downloadButton}>
        <Button exportButton onClick={onDownloadFile} loading={fetchingReport} eventName={Event.DownloadRedemptionReport}>
          Export
        </Button>
      </Field>
    </div>
  );
};

export default BooksOfAccountsFilter;
